import { apiClient } from './client';
import { AUTH_ENDPOINTS } from './endpoints';
import type {
  User,
  Tokens,
  LoginResponse,
  LoginRequest,
  RegisterRequest,
  QrSessionResponse,
  QrPollResponse,
} from '../types';

export type { User, Tokens, LoginResponse, LoginRequest, RegisterRequest, QrSessionResponse, QrPollResponse };

export const authApi = {
  login: (data: LoginRequest): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>(AUTH_ENDPOINTS.LOGIN, data);
  },

  register: (data: RegisterRequest): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>(AUTH_ENDPOINTS.REGISTER, data);
  },

  logout: (refreshToken: string): Promise<void> => {
    return apiClient.post<void>(AUTH_ENDPOINTS.LOGOUT, { refreshToken });
  },

  refreshTokens: (refreshToken: string): Promise<Tokens> => {
    return apiClient.post<Tokens>(AUTH_ENDPOINTS.REFRESH_TOKENS, { refreshToken });
  },

  createQrSession: (): Promise<QrSessionResponse> => {
    return apiClient.post<QrSessionResponse>(AUTH_ENDPOINTS.QR_SESSION, {});
  },

  confirmQrSession: (sessionCode: string): Promise<void> => {
    return apiClient.post<void>(AUTH_ENDPOINTS.QR_CONFIRM, { sessionCode }, { requiresAuth: true });
  },

  pollQrSession: (sessionCode: string): Promise<QrPollResponse> => {
    return apiClient.get<QrPollResponse>(`${AUTH_ENDPOINTS.QR_POLL}?sessionCode=${sessionCode}`);
  },
};
